package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.update_product_sets


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SetModel(
    @SerialName("category")
    val category: Category?,
    @SerialName("course")
    val course: String?,
    @SerialName("fixProducts")
    val fixProducts: List<FixProduct?>?,
    @SerialName("isCollectPoints")
    val isCollectPoints: Boolean?,
    @SerialName("maxQuantity")
    val maxQuantity: Int?,
    @SerialName("minQuantity")
    val minQuantity: Int?,
    @SerialName("priceLevel")
    val priceLevel: Int?,
    @SerialName("__typename")
    val typename: String?,
    @SerialName("weekDays")
    val weekDays: Int?,
)